import { createTheme, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

export const filtersThemeFactory = (parentTheme: Theme): Theme =>
  createTheme(parentTheme, {
    components: {
      MuiFormLabel: {
        styleOverrides: {
          filled: {
            color: colors.primary,
            '& + div:after, &.Mui-focused + div:after': {
              transform: 'scaleX(1)',
            },
            '& + div .fa-times': {
              color: colors.primary,
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          underline: {
            '&:before, &:hover:not(.Mui-disabled):before': {
              borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
            },
            '&:after': {
              borderBottom: `2px solid ${colors.primary}`,
            },
            '&.Mui-focused:after': {
              transform: 'scaleX(0)',
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            '&.Mui-error': {
              marginTop: '8px',
              minHeight: '1em',
            },
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            minHeight: '3em !important',
          },
        },
      },
    },
  });
